import { render, staticRenderFns } from "./Subscribe.vue?vue&type=template&id=2b6d95c0&scoped=true&"
import script from "./Subscribe.vue?vue&type=script&lang=js&"
export * from "./Subscribe.vue?vue&type=script&lang=js&"
import style0 from "./Subscribe.vue?vue&type=style&index=0&id=2b6d95c0&scoped=true&lang=css&"
import style1 from "vue-wysiwyg/dist/vueWysiwyg.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6d95c0",
  null
  
)

export default component.exports